import React from "react";

const DiceFormulaInput = ({
  label,
  prefix,
  formData,
  onChange,
}) => (
  <fieldset className="dice-formula-field">
    <legend>{label}</legend>
    <div className="dice-formula-input">
      <input
        aria-label={`${label} dice count`}
        min="0"
        name={`${prefix}DiceCount`}
        onChange={onChange}
        type="number"
        value={formData[`${prefix}DiceCount`] ?? ""}
      />
      <span>d</span>
      <input
        aria-label={`${label} dice sides`}
        min="0"
        name={`${prefix}DiceSides`}
        onChange={onChange}
        type="number"
        value={formData[`${prefix}DiceSides`] ?? ""}
      />
      <span>+</span>
      <input
        aria-label={`${label} constant bonus`}
        name={`${prefix}Bonus`}
        onChange={onChange}
        type="number"
        value={formData[`${prefix}Bonus`] ?? ""}
      />
    </div>
  </fieldset>
);

export default DiceFormulaInput;
